"use client";

import { SIGN_IN_LINK } from "@/app/constants";
import Link from "next/link";

export function SignInLink({ children, ...rest }) {
  return (
    <Link href={SIGN_IN_LINK} {...rest}>
      {children}
    </Link>
  );
}
